export default __webpack_public_path__ + "static/media/reims6.7a0d3b30.jpg";